import React from "react";
import { useEffect } from "react";
import { Form, Select, Input, Button, Row, Col, DatePicker, Radio } from "antd";
import StepHeader from "./StepsHeader";
import BulkOrderUpload from "../BulkOrderUpload";
import { DESTINATION_COUNTRIES, VARIANT_OPTIONS, SAMPLE_TYPES, SAMPLING_TYPES } from "../../../../../../utils/constantData";
const { Option } = Select;
const { TextArea } = Input;



// Add new order component
const AddNewOrder = ({
  onCancel,
  onNext,
  initialData = {},
  commodities = [],
  states = [],
  districts = [],
  samplers = [],
  sectors = [],
  companies = [],
  projectCodes = [],
  onFieldChange,
  userRole,
  projectData = {},
  projectConfigLoading,
  agencies
}) => {
  const [form] = Form.useForm();
  const fieldsBaseOnConfig = projectData?.projectConfig?.metadataFields || {};

  useEffect(() => {
    if (Object.keys(initialData).length > 0) {
      form.setFieldsValue(initialData);
    }
  }, [initialData, form]);

  const handleValuesChange = (changedValues, allValues) => {
    if (onFieldChange) {
      if (changedValues.state) {
        onFieldChange({
          ...allValues,
          district: undefined,
          sampler: undefined,
        });
      } else if (changedValues.district) {
        onFieldChange({
          ...allValues,
          sampler: undefined,
        });
      } else if (changedValues.agency) {
        onFieldChange({
          ...allValues,
          sampler: undefined,
        });
      } else if (changedValues.client) {
        onFieldChange({
          ...allValues,
          projectCode: undefined,
        });
      } else if (changedValues.samplingType) {
        onFieldChange({
          ...allValues,
          codewiseReason: "",
        });
      } else {
        onFieldChange(allValues);
      }
    }
  };

  return (
    <div>
      <StepHeader current={0} />

      <Form layout="vertical" form={form} onValuesChange={handleValuesChange}>
        <Row gutter={16}>
          {userRole !== "company_admin" ? (
            <Col span={12}>
              <Form.Item
                label="Client"
                name="client"
                rules={[
                  {
                    required: true,
                    message: "Please select a client",
                  },
                ]}
              >
                <Select
                  placeholder="Select client"
                  showSearch
                  optionFilterProp="children"
                >
                  {companies?.map((item) => (
                    <Option key={item._id} value={item._id}>
                      {item.companyName}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
          ) : null}
          <Col span={userRole !== "company_admin" ? 12 : 24}>
            <Form.Item
              label="Project Code"
              name="projectCode"
              rules={[
                {
                  required: true,
                  message: "Please select a project code",
                },
              ]}
            >
              <Select
                placeholder="Select project"
                showSearch
                optionFilterProp="children"
                disabled={userRole !== "company_admin" && !initialData.client}
              >
                {projectCodes?.map((item) => (
                  <Option key={item._id} value={item._id}>
                    {item.projectCode}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
          {fieldsBaseOnConfig?.agency?.required === true ? (
            <Col span={12}>
              <Form.Item
                label="Agency"
                name="agency"
                rules={[
                  {
                    required: fieldsBaseOnConfig?.agency?.mandatory === true,
                    message: "Please select an agency",
                  },
                ]}
              >
                <Select
                  placeholder="Select agency"
                  showSearch
                  optionFilterProp="children"
                >
                  {agencies?.map((item) => (
                    <Option key={item._id} value={item._id}>
                      {item.agencyName}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
          ) : null}
          {fieldsBaseOnConfig?.commodity?.required === true ? (
            <Col span={12}>
              <Form.Item
                label="Commodity"
                name="commodity"
                rules={[
                  {
                    required: fieldsBaseOnConfig?.commodity?.mandatory === true,
                    message: "Please select a commodity",
                  },
                ]}
              >
                <Select
                  placeholder="Select commodity"
                  showSearch
                  optionFilterProp="children"
                >
                  {commodities?.map((item) => (
                    <Option key={item._id} value={item._id}>
                      {item.name}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
          ) : null}
          {fieldsBaseOnConfig?.variant?.required === true ? (
            <Col span={12}>
              <Form.Item
                label="Variant"
                name="variant"
                rules={[
                  {
                    required: fieldsBaseOnConfig?.variant?.mandatory === true,
                    message: "Please select a variant",
                  },
                ]}
              >
                <Select placeholder="Select variant">
                  {VARIANT_OPTIONS.map((option) => (
                    <Option key={option.value} value={option.value}>
                      {option.label}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
          ) : null}
          {fieldsBaseOnConfig?.sampleType?.required === true ? (
            <Col span={12}>
              <Form.Item
                label="Sample Type"
                name="sampleType"
                rules={[
                  {
                    required:
                      fieldsBaseOnConfig?.sampleType?.mandatory === true,
                    message: "Please select a sample type",
                  },
                ]}
              >
                <Select placeholder="Select sample type">
                  {SAMPLE_TYPES.map((option) => (
                    <Option key={option.value} value={option.value}>
                      {option.label}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
          ) : null}
          {fieldsBaseOnConfig?.sector?.required === true ? (
            <Col span={12}>
              <Form.Item
                label="Sector"
                name="sector"
                rules={[
                  {
                    required: fieldsBaseOnConfig?.sector?.mandatory === true,
                    message: "Please select a sector",
                  },
                ]}
              >
                <Select
                  placeholder="Select sector"
                  showSearch
                  optionFilterProp="children"
                >
                  {sectors?.map((item) => (
                    <Option key={item.value} value={item.value}>
                      {item.label}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
          ) : null}
          {fieldsBaseOnConfig?.state?.required === true ? (
            <Col span={12}>
              <Form.Item
                label="State"
                name="state"
                rules={[
                  {
                    required: fieldsBaseOnConfig?.state?.mandatory === true,
                    message: "Please select a state",
                  },
                ]}
              >
                <Select
                  placeholder="Select state"
                  showSearch
                  optionFilterProp="children"
                >
                  {states?.map((item) => (
                    <Option key={item._id} value={item._id}>
                      {item.name}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
          ) : null}
          {fieldsBaseOnConfig?.district?.required === true ? (
            <Col span={12}>
              <Form.Item
                label="District"
                name="district"
                rules={[
                  {
                    required: fieldsBaseOnConfig?.district?.mandatory === true,
                    message: "Please select a district",
                  },
                ]}
              >
                <Select
                  placeholder="Select district"
                  showSearch
                  optionFilterProp="children"
                  disabled={!initialData.state}
                >
                  {districts?.map((item) => (
                    <Option key={item._id} value={item._id}>
                      {item.city}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
          ) : null}
          {fieldsBaseOnConfig?.destinationCountry?.required === true ? (
            <Col span={12}>
              <Form.Item
                label="Destination Country"
                name="destinationCountry"
                rules={[
                  {
                    required:
                      fieldsBaseOnConfig?.destinationCountry?.mandatory ===
                      true,
                    message: "Please select destination country",
                  },
                ]}
              >
                <Select placeholder="Select destination country">
                  {DESTINATION_COUNTRIES.map((country) => (
                    <Option key={country.value} value={country.value}>
                      {country.label} ({country.isoCode})
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
          ) : null}
          {fieldsBaseOnConfig?.samplingType?.required === true ? (
            <Col span={12}>
              <Form.Item
                label="Sampling Type"
                name="samplingType"
                rules={[
                  {
                    required:
                      fieldsBaseOnConfig?.samplingType?.mandatory === true,
                    message: "Please select sampling type",
                  },
                ]}
              >
                <Radio.Group>
                  {SAMPLING_TYPES.map((option) => (
                    <Radio key={option.value} value={option.value}>
                      {option.label}
                    </Radio>
                  ))}
                </Radio.Group>
              </Form.Item>
            </Col>
          ) : null}
          {form.getFieldValue("samplingType") === "Code-wise Sampling" && (
            <Col span={12}>
              <Form.Item
                label="Code-wise Reason"
                name="codewiseReason"
                rules={[
                  { required: true, message: "Please enter code-wise reason" },
                ]}
              >
                <TextArea placeholder="Enter code-wise reason" rows={1} />
              </Form.Item>
            </Col>
          )}
          {fieldsBaseOnConfig?.expectedConsignmentReadiness?.required ===
          true ? (
            <Col span={12}>
              <Form.Item
                label="Expected Consignment Readiness"
                name="expectedConsignmentReadiness"
                rules={[
                  {
                    required:
                      fieldsBaseOnConfig?.expectedConsignmentReadiness
                        ?.mandatory === true,
                    message:
                      "Please select expected consignment readiness date",
                  },
                ]}
              >
                <DatePicker
                  style={{ width: "100%" }}
                  placeholder="Select date"
                  format="DD-MM-YYYY"
                />
              </Form.Item>
            </Col>
          ) : null}
          {fieldsBaseOnConfig?.expectedShipmentDate?.required === true ? (
            <Col span={12}>
              <Form.Item
                label="Expected Shipment Date"
                name="expectedShipmentDate"
                rules={[
                  {
                    required:
                      fieldsBaseOnConfig?.expectedShipmentDate?.mandatory ===
                      true,
                    message: "Please select expected shipment date",
                  },
                ]}
              >
                <DatePicker
                  style={{ width: "100%" }}
                  placeholder="Select date"
                  format="DD-MM-YYYY"
                />
              </Form.Item>
            </Col>
          ) : null}
          {userRole !== "company_admin" &&
          fieldsBaseOnConfig?.sampler?.required === true ? (
            <Col span={12}>
              <Form.Item
                label="Sampler (Optional)"
                name="sampler"
                rules={[
                  {
                    required: fieldsBaseOnConfig?.sampler?.mandatory === true,
                    message: "Please select a sampler",
                  },
                ]}
              >
                <Select
                  placeholder="Select sampler"
                  showSearch
                  optionFilterProp="children"
                  disabled={!initialData.district || !initialData.agency}
                >
                  {samplers?.map((item) => (
                    <Option key={item._id} value={item._id}>
                      {item.name}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
          ) : null}
          {fieldsBaseOnConfig?.siteAddress?.required === true ? (
            <Col span={12}>
              <Form.Item
                label="Site Address (Optional)"
                name="siteAddress"
                rules={[
                  {
                    required:
                      fieldsBaseOnConfig?.siteAddress?.mandatory === true,
                    message: "Please enter site address",
                  },
                ]}
              >
                <Input placeholder="Enter pickup location address" />
              </Form.Item>
            </Col>
          ) : null}
        </Row>

        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginTop: 20,
          }}
        >
          {/* Left */}
          <Button onClick={onCancel}>Cancel</Button>

          {/* Right group */}
          <div style={{ display: "flex", gap: 12 }}>
            <BulkOrderUpload onBulkSuccess={onCancel} />
            <Button
              type="primary"
              loading={projectConfigLoading}
              onClick={() => {
                form
                  .validateFields()
                  .then((values) => onNext(values))
                  .catch(() => {});
              }}
            >
              Next →
            </Button>
          </div>
        </div>
      </Form>
    </div>
  );
};

export default AddNewOrder;
